<p><b>{{ title }}</b></p>
<p>{{ message }}</p>
<div id="smr-confirmation-buttons">
    <button type="button" mat-button 
        (click)="mdDialogRef.close()">No</button>
    <button type="button" mat-raised-button 
        (click)="mdDialogRef.close(true)">Yes</button>
</div>